import React, { useState } from 'react';
import { useNotification } from '../contexts/NotificationsContext';
import { getTodayDate } from '../utils/formatDates';
import convertToOvariant from '../utils/convertToOvariant';
import api from '../services/api';
import endpoints from '../utils/commonVariables/endpoints';
import TermsAndConditionsContent from '../components/termsAndConditions/TermsAndConditions';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import PopUp from '../muiComponents/PopUp';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import '../stylesheets/stylesPopUp/termsAndConditionsPopUp.scss';
import { savableEntities } from '../utils/commonVariables/entityKeys';
import { useHotelOwner, useIdHotelOwner } from '../contexts/HotelOwnerContext';
import useTranslate from '../customHooks/useTranslate';
import useUserProfile from '../customHooks/useUserProfile';

const TermsAndConditionsPopUp = () => {
    const { readOnlyUser } = useUserProfile();
    const IdHotelOwner = useIdHotelOwner();
    const translate = useTranslate();
    const { ownerData, updateOwnerData } = useHotelOwner();
    const { setNotificationMessage, setErrorMessage } = useNotification();
    const [isPopUpLoading, setIsPopUpLoading] = useState(false);

    const [isClosedPopUp, setIsClosedPopUp] = useState(false);
    const [isCheckedTerms, setIsCheckedTerms] = useState(false);

    const errorMessageBar = {
        text: 'something_went_wrong',
        componentText: null,
        snackbarProps: { position: 2 },
        alertProps: { severity: 'error' },
    };
    const successMessageBar = {
        text: 'success_message',
        componentText: null,
        snackbarProps: { position: 2 },
        alertProps: { severity: 'success' },
    };

    const handleClose = () => {
        setIsClosedPopUp(true);
    };

    const onAcceptTermsAndConditions = async () => {
        const dataToSend = {
            Signed: true,
            DateSigned: getTodayDate(),
        };
        const objectToSend = convertToOvariant(
            savableEntities.HotelOwner,
            dataToSend,
            IdHotelOwner
        );

        if (isCheckedTerms) {
            try {
                setIsPopUpLoading(true);
                const endpoint = endpoints.commonSave;
                const res = await api.post(endpoint, objectToSend);
                const resStatus = res?.status;
                if (resStatus === 201) {
                    updateOwnerData({
                        signed: true,
                        idCurrency: ownerData?.idCurrency,
                        currency: ownerData?.currency,
                    });
                    setNotificationMessage(successMessageBar);
                    handleClose();
                } else {
                    setNotificationMessage(errorMessageBar);
                }
            } catch {
                setErrorMessage(errorMessageBar);
            } finally {
                setIsPopUpLoading(false);
            }
        }
    };

    const onCheckTermsAndConditions = () => {
        setIsCheckedTerms(!isCheckedTerms);
    };

    return (
        <>
            {ownerData && !ownerData?.signed && (
                <div className='container__popup'>
                    <PopUp
                        open={!isClosedPopUp}
                        titleText='title_terms_conditions'
                        maxWidth='lg'
                        className='container__popup--custom__dialog'
                        actions={
                            <DialogActions classes={{ root: 'dialog__footer' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color='success'
                                            onChange={onCheckTermsAndConditions}
                                            checked={isCheckedTerms}
                                            disabled={readOnlyUser}
                                        />
                                    }
                                    label={translate('I_have_read_terms')}
                                    classes={{ root: 'dialog__checkbox' }}
                                />
                                <Button
                                    size='small'
                                    variant='contained'
                                    className='accept__button'
                                    onClick={onAcceptTermsAndConditions}
                                    disabled={
                                        !isCheckedTerms ||
                                        readOnlyUser ||
                                        isPopUpLoading
                                    }
                                >
                                    {translate('accept')}
                                </Button>
                            </DialogActions>
                        }
                    >
                        {readOnlyUser && (
                            <Alert severity='warning'>
                                {translate('read_only_terms')}
                            </Alert>
                        )}
                        <div className='dialog__content'>
                            <TermsAndConditionsContent />
                        </div>
                    </PopUp>
                </div>
            )}
        </>
    );
};

export default TermsAndConditionsPopUp;
